import { Modal } from "react-bootstrap";
import { Button } from "./Controls/Button";
import { HeaderText } from "./Controls/HeaderText";

type UnsavedChangesModalProps = {
  show: boolean;
  onStay: () => void;
  onDiscard: () => void;
};

export function UnsavedChangesModal({
  show,
  onStay,
  onDiscard,
}: UnsavedChangesModalProps) {
  return (
    <Modal show={show} onHide={onStay} centered>
      <Modal.Header closeButton>
        <HeaderText className="d-flex align-items-center gap-2">
          <span className="fs-5">⚠️</span>
          <span>Unsaved Changes</span>
        </HeaderText>
      </Modal.Header>

      <Modal.Body>
        <div className="alert alert-warning mb-0">
          <div>
            <div className="fw-semibold mb-1">
              You have unsaved changes on this page.
            </div>

            <div className="small text-muted">
              If you leave now, your changes will be permanently discarded.
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onDiscard}>Discard Changes</Button>

        <Button className="btn-main" onClick={onStay}>
          Stay on Page
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
